<template>
  <div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong>{{ snackbar.title }}</strong>
          </div>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-app-bar
        v-if="languageData.header"
        elevation="0"
        class="main-header"
        height="100"
        fixed
        :key="headerKey"
        color='bgDefault'
        dark>

      <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER" v-if="!layoutIsUser">
        <template v-if="DRAWER_STATE">
          <v-icon size="28" color="fontDefault" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-arrow-left</v-icon>
        </template>
        <template v-else>
          <v-icon size="28" color="fontDefault" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-menu</v-icon>
        </template>
      </v-btn>
      <v-img
          v-if="this.$route.name !== 'LoginMain' || (this.$route.name === 'LoginMain' && !$vuetify.breakpoint.lgAndUp)"
          lazy-src="../../assets/logo.png"
          :max-width="$vuetify.breakpoint.mdAndUp ? '254px' : '150px'"
          src='../../assets/logo.png'
      ></v-img>
      <v-spacer></v-spacer>

      <v-menu
          class="update-status-task-tooltip"
          max-width="500"
          offset-y
          bottom
          nudge-bottom="10"
          left
          v-if="user && !$vuetify.breakpoint.xsOnly"
          :close-on-content-click="false"
          :close-on-click="handleTasksDialogVisible"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              @click="loadTasks"
              style="font-size: 14px;"
              text
              color="#252B42"
              class="mr-2">
            <v-icon
                class="mr-2"
                size="30"
                color="fontDefault">
              mdi-format-list-checks</v-icon>
            {{ $vuetify.breakpoint.lgAndUp ? languageData.header.tasks : null}}
          </v-btn>
        </template>
        <v-list class="px-10">
          <p class="text-h5 grey--text text--darken-3 px-4 pt-4"> {{ languageData.header.tasks }} </p>
          <v-select
              class="mt-5"
              :label="languageData.select_project"
              v-model="projectSelected"
              @change="loadTasks"
              :items="getProjectsToSelect()"
              outlined
              item-value="id"
              item-text="name"
          >
            <template slot='selection' slot-scope='{ item }'>
              {{ item.name  }}
            </template>
            <template slot='item' slot-scope='{ item }'>
              {{ item.name  }}
            </template>
          </v-select>
          <div class="mt-5 mb-5" v-if="isLoadingTasks">
            <v-progress-circular
                indeterminate
                color="primary">
            </v-progress-circular>
          </div>
          <div class="mb-5 text-right">
            <v-btn v-if="projectSelected !== null" @click="createProjectTask" color="primary">
              <v-icon class="mr-2">mdi-plus</v-icon>
              {{ languageData.btnAddProjectTask }}
            </v-btn>
          </div>
          <v-list-item v-if="!isLoadingTasks && tasks.length == 0 && projectSelected !== null">
            <v-list-item-title> {{ languageData.header.noTasks }} </v-list-item-title>
          </v-list-item>
          <v-list-item-group color="primary" >
            <v-list-item
                v-for="(item, i) in tasks"
                :key="i"
                class="pl-0"
            >
              <v-list-item two-line disabled class="text-left">
                <v-list-item-content>
                  <v-list-item-title v-text="item.title" class="pb-2"></v-list-item-title>
                  <v-list-item-subtitle v-text="item.description" class="text-truncate"></v-list-item-subtitle >
                  <small v-if="item.execution_day" v-text="languageData.executionDayTask + ' ' + item.execution_day" class="text-truncate mt-2"></small>
                  <small v-text="languageData.createdAtTask + ' ' + item.created_at" class="text-truncate mt-2"></small>
                </v-list-item-content>
              </v-list-item>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-select
                      class="task-status-select"
                      v-bind="attrs"
                      v-on="on"
                      v-model="taskStatusTypes.filter(el => el.value == item.status)[0]"
                      @change="updateStatusTask($event, item)"
                      :items="taskStatusTypes"
                      item-value="value"
                      item-text="tooltip"
                  >
                    <template slot='selection' slot-scope='{ item }'>
                      {{ item.tooltip  }}
                    </template>
                    <template slot='item' slot-scope='{ item }'>
                      {{ item.tooltip  }}
                    </template>
                  </v-select>
                </template>
              </v-tooltip>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>


      <v-menu
          max-width="340"
          offset-y
          bottom
          nudge-bottom="10"
          left
          :close-on-content-click="false"
          v-if="user && !$vuetify.breakpoint.xsOnly"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              @click="loadContacts"
              style="font-size: 14px"
              text
              color="#252B42">
            <v-icon
                class="mr-3"
                size="30"
                color="fontDefault">
              mdi-card-account-phone</v-icon>
            {{ $vuetify.breakpoint.lgAndUp ? languageData.header.plannedContacts : null}}
          </v-btn>
        </template>
        <v-list>
          <div class="text-h5 grey--text text--darken-3 px-4 pt-4"> {{ languageData.header.plannedContacts }} </div>
          <div class="mt-5 mb-5" v-if="isLoadingContacts">
            <v-progress-circular
                indeterminate
                color="primary">
            </v-progress-circular>
          </div>
          <v-list-item v-if="!isLoadingContacts && plannedContacts.length == 0">
            <v-list-item-title> {{ languageData.header.noContacts }} </v-list-item-title>
          </v-list-item>
          <v-list-item-group color="primary" >
            <v-list-item
                v-for="(item, i) in plannedContacts"
                :key="i"
            >
              <v-list-item two-line >
                <v-list-item-content>
                  <v-list-item-title v-text="item.client_name" class="pb-2"></v-list-item-title>
                  <v-list-item-subtitle v-if="item.project_name != null" v-text="item.project_name" class="text-truncate"></v-list-item-subtitle>
                  <v-list-item-subtitle v-text="item.planned_at" class="text-truncate"></v-list-item-subtitle>
                  <v-list-item-subtitle v-text="item.description" class="text-truncate"></v-list-item-subtitle >
                </v-list-item-content>
              </v-list-item>
              <v-btn
                  medium
                  color="primary"
                  class="text-capitalize"
                  @click="previewContact(i)"
              >
                {{ languageData.header.openContant }}
              </v-btn>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-menu
          max-width="280"
          offset-y
          bottom
          nudge-bottom="10"
          left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              style="font-size: 14px"
              text
              color="#252B42"
              class="language-header-button">
            <country-flag :country="activeCountry" size='normal' class="ma-0"/>
            {{ $vuetify.breakpoint.lgAndUp ? languageData.header.language : null}}
          </v-btn>
        </template>
        <v-list style="overflow-y:auto; height: 500px">
          <v-list-item-group color="primary" >
            <v-list-item
                @click="updateLanguageSite(item)"
                v-for="(item, i) in messages"
                :key="i"
            >
              <v-list-item-icon class="mr-4 mb-1 d-flex flex-column">
                <country-flag :country='item.value' size='normal'/>
              </v-list-item-icon>
              <v-list-item two-line >
                <v-list-item-content style="width: 100px">
                  <v-list-item-title v-text="valueToUppercase(getLanguage(item.langIso))" class="mt-1"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-menu
          max-width="280"
          offset-y
          bottom
          nudge-bottom="10"
          left
          v-if="user"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-avatar
              size="40"
              v-bind="attrs"
              v-on="on"
              class="mr-2">
            <img
                :src="companyData.logo"
                class="logoCompanyHeader"
            >
          </v-avatar>
        </template>
        <v-list >
          <div class="text-h5 grey--text text--darken-3 px-4 pt-4">{{ companyData.name }}</div>
          <div class="subtitle-2 primary--text font-weight-regular px-4">{{ companyData.firstname }} {{ companyData.lastname }}</div>
          <div class="d-flex justify-center my-3">
            <v-btn
                width="80%"
                large
                outlined
                color="primary"
                class="text-capitalize"
                @click="logoutUser"
            >{{ languageData.header.logout }}</v-btn>
          </div>
        </v-list>
      </v-menu>
      <div v-if="user" class="greeting-text mr-3 d-none d-md-block">{{ languageData.header.hello }}, <span>{{ companyData.userName }}</span></div>
      <ModalInfo :hidden-agree-btn="true" @clicked="hideModal" :show-modal="isVisibleProjectTaskModal">
        <template v-slot:body>
          <ProjectTasksForm :selectedProjectId="projectSelected"></ProjectTasksForm>
        </template>
      </ModalInfo>
    </v-app-bar>
  </div>
</template>


<script type="text/javascript">
import config from "../../config";
import {mapActions, mapState} from "vuex";
import CountryFlag from "vue-country-flag";
import eventBus from "../../event-bus/eventBus";
import router from '../../../router';
import taskStatusTypes from '../../modules/ProjectTasks/enums/taskStatusTypes';
import ModalInfo from "../../components/ModalInfo/ModalInfo.vue";
import ProjectTasksForm from "../../modules/ProjectTasks/components/ProjectTasksForm.vue";

export default {
  name: "Header",
  components: {
    CountryFlag, ModalInfo, ProjectTasksForm
  },
  props: {
    layout: String,
  },
  data: () => ({
    config,
    messages: [
      {value: "gb", langIso: 'gb'},
      {value: "pl", langIso: 'pl'},
      {value: "de", langIso: 'de'},
      {value: 'ro', langIso: 'ro'},
      {value: 'al', langIso: 'sq'},
      {value: 'bg', langIso: 'bg'},
      {value: 'hu', langIso: 'hu'},
      {value: 'cz', langIso: 'cs'},
      {value: 'sy', langIso: 'ar'},
      {value: 'tr', langIso: 'tr'},
      {value: 'fr', langIso: 'fr'},
      {value: 'af', langIso: 'ps'},
      {value: 'iq', langIso: 'ar'},
      {value: 'it', langIso: 'it'},
    ],
    headerKey: 0,
    companyData: {
      logo: localStorage.getItem("companyLogo"),
      firstname: localStorage.getItem("companyFirstName") === "undefined" || localStorage.getItem("companyFirstName") === "null"  ? "" : localStorage.getItem("companyFirstName"),
      name: localStorage.getItem("companyName") === "undefined" || localStorage.getItem("companyName") === "null"  ? "" : localStorage.getItem("companyName"),
      lastname: localStorage.getItem("companyLastName") === "undefined" || localStorage.getItem("companyLastName") === "null"  ? "" : localStorage.getItem("companyLastName"),
      isVatPayer: localStorage.getItem("companyIsVatPayer") === "undefined" || localStorage.getItem("companyIsVatPayer") === "null"  ? "" : localStorage.getItem("companyIsVatPayer"),
      userName: localStorage.getItem("userName"),
    },
    user: localStorage.getItem("tokenAuth"),
    plannedContacts: [],
    projectSelected: null,
    tasks: [],
    isTasksDialogVisible: false,
    snackbar: {
      color: null,
      icon: null,
      mode: null,
      position: null,
      text: null,
      corner: null,
      timeout: 7500,
      title: null,
      visible: false
    },
  }),
  methods: {
    ...mapActions('loginMain', ['logoutUser']),
    ...mapActions("layoutCompany", ['TOGGLE_DRAWER']),
    ...mapActions('getCompanyUser', ['getCompanyUser']),
    ...mapActions("getOldestsPlannedContacts", ["getOldestsPlannedContacts"]),
    ...mapActions("getProjects", ["getProjects"]),
    ...mapActions("getTodoTasks", ["getTodoTasks", 'getLatestTasks']),
    ...mapActions("updateProjectTask", ["updateProjectTask"]),
    ...mapActions("updateVisibleProjectTaskModal", ["updateVisibleProjectTaskFormModalFromHeader"]),
    ...mapActions("updateVisibleTimeReportSummaryTableModal", ["updateVisibleTimeReportSummaryTableModal"]),
    ...mapActions("preventDataLost", ["updateDataInFormIsChanged"]),

    valueToUppercase(value) {
      return value.toUpperCase();
    },
    updateLanguageSite: function (item) {
      this.updateLanguage(item.langIso);
      eventBus.$emit('changeLanguage', item.langIso); 
      this.updateCountryFlag(item.value)
    },
    getCompanyLogo: function() {
      return localStorage.getItem("companyLogo");
    },
    previewContact: function(i) {
        if(this.plannedContacts[i].project_id === null)
        {
          router.push({ name: 'ClientsEdit', query: { id: this.plannedContacts[i].client_id }}).catch( () => {});
        }
        else
        {
          router.push({ name: 'ProjectsEdit', query: { id: this.plannedContacts[i].project_id }}).catch( () => {});
        }
    },
    loadContacts: function() {
      this.plannedContacts = [];
      this.getOldestsPlannedContacts();
    },
    loadTasks: function() {
      this.tasks = [];
      this.getTodoTasks(this.projectSelected);
    },
    updateStatusTask: function (event, item) {
      this.isTasksDialogVisible = true;
      let id = item.id;
      let data = item;
      data.status = event;
      data.projectId = this.projectSelected;
      this.updateProjectTask({creds: {id, data}});
    },
    createProjectTask: function() {
      this.isTasksDialogVisible = true;
      this.updateVisibleProjectTaskFormModalFromHeader(true);
      eventBus.$emit("clearProjectTaskFormModal");
    },
    hideModal: function() {
       this.updateVisibleProjectTaskFormModalFromHeader(false);
       this.isTasksDialogVisible = false;
    },
    getProjectsToSelect() {
      let all = [
        {
          name: this.languageData.header.allTasks,
          id: null,
          value: null
        }
      ];
      const projects = Array.from(this.projects)
      return all.concat(projects);
    },
    getSnackbarSuccess: function(title, message, top = false) {
      this.snackbar = {
        color: "success",
        icon: "check_circle",
        mode: "multi-line",
        position: top,
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
    getSnackbarFailure: function(title, message, top = false) {
      this.snackbar = {
        color: "error",
        icon: "error",
        mode: "multi-line",
        position: top,
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
     getLanguage(lang) {
      switch (lang) {
        case 'gb':
          return 'English'  
        case 'pl':
          return 'Polski'
        case 'de':
          return 'Deutsch'
        case 'ro':
          return 'Română'
        case 'sq':
          return 'Shqiptare'
        case 'bg':
          return 'български'
        case 'hu':
          return 'Magyar'
        case 'cs':
          return 'Ceština'
        case 'ar':
          return 'عربي'
        case 'tr':
          return 'Türk'
        case 'fr':
          return 'Français'
        case 'ps':
          return 'پښتو'
        case 'it':
          return 'Italiano'
      }
    }
  },
  computed: {
    ...mapState("getOldestsPlannedContacts", { 
      isLoadingContacts: state => state.isLoadingContacts
    }),
     ...mapState("updateVisibleProjectTaskModal", {
      isVisibleProjectTaskModal: state => state.isModalVisibleFromHeader,
    }),
    ...mapState('layoutCompany',
        {drawer: state => state.drawer}
    ),
    ...mapState("getProjects", {
      projects: state => state.dataReceive
    }),
    ...mapState("getTodoTasks", {
      isLoadingTasks: state => state.isLoadingTasks
    }),
    taskStatusTypes() {
      return taskStatusTypes.data;
    },
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
    },
    layoutIsUser: function () {
      return this.layout === "userLayout";
    },
    handleTasksDialogVisible() {
      if (this.isTasksDialogVisible) {
        return false
      } else {
        return true
      }
    },
  },
  mounted() {
    this.updateLanguage(this.getCurrentLanguage);
    this.updateCountryFlag(this.getCurrentCountry);
    eventBus.$on("getLanguageSuccess", () => {
      taskStatusTypes.updateLanguage(this.languageData);
      this.status = taskStatusTypes.data;
    });
    eventBus.$on("getOldestContactsSuccess", (data) => {
      data.forEach( (el) => {
        if(el.description.length > 25) {
          el.description = el.description.slice(0, 22) + "...";
        }
      });
        this.plannedContacts = data;
    });
    eventBus.$on("getTodoTasksSuccess", (data) => {
      data.forEach( (el) => {
        if(el.description === null) {
          el.description = '';
        } else if(el.description.length > 25) {
          el.description = el.description.slice(0, 22) + "...";
        }});
      this.tasks = data;
    });
    eventBus.$on("getLatestTodoTasksSuccess", (data) => {
      data.forEach( (el) => {
        if(el.description === null) {
          el.description = '';
        } else if(el.description.length > 25) {
          el.description = el.description.slice(0, 22) + "...";
        }});
      this.tasks = data;
    });
    eventBus.$on("updateMyCompany", () => {
      this.companyData.logo = localStorage.getItem("companyLogo");
      this.companyData.firstname = localStorage.getItem("companyFirstName") === "undefined" || localStorage.getItem("companyFirstName") === "null"  ? "" : localStorage.getItem("companyFirstName");
      this.companyData.name = localStorage.getItem("companyName") === "undefined" || localStorage.getItem("companyName") === "null"  ? "" : localStorage.getItem("companyName");
      this.companyData.lastname = localStorage.getItem("companyLastName") === "undefined" || localStorage.getItem("companyLastName") === "null"  ? "" : localStorage.getItem("companyLastName");
      this.companyData.isVatPayer = localStorage.getItem("companyIsVatPayer") === "undefined" || localStorage.getItem("companyIsVatPayer") === "null"  ? "" : localStorage.getItem("companyIsVatPayer");
      this.headerKey += 1;
    });
    if(this.$route.name !== 'LoginMain') {
      this.getCompanyUser();
    }
    eventBus.$on("updateProjectTaskSuccess", (dataReceive) => {
      this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
      this.isTasksDialogVisible = false;
      this.getTodoTasks(this.projectSelected);
    });
    eventBus.$on("deleteProjectTaskSuccess", (dataReceive) => {
      this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
    });
    eventBus.$on("saveProjectTaskSuccess", (dataReceive) => {
      this.updateVisibleProjectTaskFormModalFromHeader(false);
      this.isTasksDialogVisible = false;
      this.getTodoTasks(this.projectSelected);
      this.getSnackbarSuccess(dataReceive.title, dataReceive.message, true);
      this.task = {
        title: '',
        description: '',
        status: 0
      }
      eventBus.$emit("getProjectTasks");
    });
    eventBus.$on("projectDiskLimitExceeded", (data) => {
      this.getSnackbarFailure(data.message[0], data.textInfo[0], true);
      this.updateDataInFormIsChanged(false);
    });
    eventBus.$on("sendTimeReportSuccess", (snackbarData) => {
      this.getSnackbarSuccess(snackbarData.title, snackbarData.message, true);
    });
    eventBus.$on("deleteInvoicePaymentItemSuccess", (snackbarData) => {
      this.getSnackbarSuccess(snackbarData.title, snackbarData.message, true);
    });
  },
  beforeDestroy() {
    eventBus.$off('updateProjectTaskSuccess');
    eventBus.$off('saveProjectTaskSuccess');
  }
}

</script>

<style src="./Header.scss" lang="scss" scoped></style>